import { $api } from "@/shared/api/api";
import { IApp } from "@/shared/types/apps";

// Query Functions для TanStack Query
export default class AppsService {
  // Получение списка всех приложений/игр (для query)
  // Использует /web/app/ согласно новой документации
  static async getApps(slug?: string): Promise<IApp[]> {
    const params = slug ? { slug } : {};
    const response = await $api.get<IApp[]>(`/web/app/`, { params });
    return response.data;
  }

  // Получение приложения по ID (для query)
  // Использует /web/app/{id}/ согласно новой документации
  static async getAppById(appId: string | number): Promise<IApp> {
    const response = await $api.get<IApp>(`/web/app/${appId}/`);
    return response.data;
  }

  // Получение приложения по slug (для query)
  // В новой документации нет отдельного эндпоинта для slug, используем getApps с параметром slug
  static async getAppBySlug(slug: string): Promise<IApp | undefined> {
    const apps = await this.getApps(slug);
    return apps.find((app) => app.slug === slug);
  }

  // Получение URL для запуска приложения
  // Использует /web/app/{id}/launch/ согласно новой документации
  static async getAppUrl(
    app_id: string | number,
  ): Promise<{ signed_url: string }> {
    const response = await $api.get<{ signed_url: string }>(
      `/web/app/${app_id}/launch/`,
    );
    return response.data;
  }

  // Создание приложения (для mutation)
  // Использует /web/app/ (POST) согласно новой документации
  static async createApp(data: Partial<IApp>): Promise<IApp> {
    const response = await $api.post<IApp>(`/web/app/`, data);
    return response.data;
  }

  // Обновление приложения (для mutation)
  // Использует /web/app/{id}/ (PUT) согласно новой документации
  static async updateApp(
    appId: string | number,
    data: Partial<IApp>,
  ): Promise<IApp> {
    const response = await $api.put<IApp>(`/web/app/${appId}/`, data);
    return response.data;
  }

  // Частичное обновление приложения (для mutation)
  // Использует /web/app/{id}/ (PATCH) согласно новой документации
  static async patchApp(
    appId: string | number,
    data: Partial<IApp>,
  ): Promise<IApp> {
    const response = await $api.patch<IApp>(`/web/app/${appId}/`, data);
    return response.data;
  }

  // Удаление приложения (для mutation)
  // Использует /web/app/{id}/ (DELETE) согласно новой документации
  static async deleteApp(appId: string | number): Promise<void> {
    await $api.delete(`/web/app/${appId}/`);
  }
}
